import React, { FC, useCallback } from 'react'
import { Container } from 'react-bootstrap'
import { Videos } from 'new-architecture/components/videos'
import { PropertyTeaserType } from 'store/properties/types'
import { PropertyAdditionalMaterialsTitle } from './property-additional-materials-title'
import { useTrackTeaserProductVideoOpenedMutation } from 'api/analitics'

interface AdditionalMaterialsProps {
  property: PropertyTeaserType
}

export const AdditionalMaterials: FC<AdditionalMaterialsProps> = ({ property }) => {
  const { sectionAssets } = property;
  const { additionalMaterials: additionalMaterialsVideos } = sectionAssets || {};

  const [trackProductVideoOpened] = useTrackTeaserProductVideoOpenedMutation();
  const onOpenVideo = useCallback((videoUrl: string) => {
    trackProductVideoOpened({
      opportunity: property.name,
      opportunityId: property._id,
      productVideoUrl: videoUrl
    });
  }, [trackProductVideoOpened, property]);

  return (
    <Container className="mb-3">
      <PropertyAdditionalMaterialsTitle />
      <Videos videos={additionalMaterialsVideos || []} onOpenVideo={onOpenVideo} />
    </Container>
  )
}